import { render, staticRenderFns } from "./SummaryContent.vue?vue&type=template&id=33571ff4&"
import script from "./SummaryContent.vue?vue&type=script&lang=js&"
export * from "./SummaryContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports